import React from 'react';

export const LearningPlatform = ({ text, logo, link, subtitle }) => {
  return (
    <a
      href={link}
      rel="noopener noreferrer"
      target="_blank"
      className="learning-platform"
    >
      <img alt="learning-platform" src={`${logo}`}></img>

      {subtitle ? (
        <div className="d-flex flex-column">
          <span className="learning-platform-name">{text}</span>
          <span className="learning-platform-subtitle">{subtitle}</span>
        </div>
      ) : (
        <span className="learning-platform-name">{text}</span>
      )}
    </a>
  );
};

export default LearningPlatform;
